var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_tuuwa"},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fas fa-video"}),_vm._v("通話 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }